import { render } from "./HomeDashboardComment.vue?vue&type=template&id=2d14878c"
import script from "./HomeDashboardComment.vue?vue&type=script&lang=js"
export * from "./HomeDashboardComment.vue?vue&type=script&lang=js"

import "./HomeDashboardComment.vue?vue&type=style&index=0&id=2d14878c&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__